(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/pages/order-home/preview-coverletter/components/envelope-cross.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/pages/order-home/preview-coverletter/components/envelope-cross.js');
"use strict";

const EnvelopeCross = () => React.createElement(React.Fragment, null, React.createElement("div", {
  className: "cross-line"
}), React.createElement("div", {
  className: "cross-line"
}));
setGlobal('svs.ticketOrderHome.pages.previewCoverLetter.components.EnvelopeCross', EnvelopeCross);

 })(window);